export const DEFAULT_WORKING_HOUR_START_TIME = '00:00';
export const DEFAULT_WORKING_HOUR_END_TIME = '24:00';
